import getLoyaltyDefaultTier from 'loyalty/selectors/getLoyaltyDefaultTier'

/**
 * @returns the tier to display to the user
 * - If the user has an account we should display their current tier
 * - If the user does not have an account we should display their eligible tier fetched from the service
 * - Fallback to the default tier if necessary
 */
function getLoyaltyDisplayTier(state: App.State): App.LoyaltyTier {
  const accountTier = state.loyalty.account.data?.tier

  return accountTier ?? getLoyaltyDefaultTier()
}

export default getLoyaltyDisplayTier
